// extracted by mini-css-extract-plugin
export default {"row":"_27mr9"};